import { useState, useContext, createContext, ReactNode, Dispatch, SetStateAction } from 'react';

// Define the context value type
interface ModalContextType {
  isAnyModalOpen: boolean;
  setIsAnyModalOpen: Dispatch<SetStateAction<boolean>>;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

interface ModalProviderProps {
  children: ReactNode;
}

export function ModalProvider({ children }: ModalProviderProps) {
  const [isAnyModalOpen, setIsAnyModalOpen] = useState(true);

  return (
    <ModalContext.Provider value={{ isAnyModalOpen, setIsAnyModalOpen }}>
      {children}
    </ModalContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
